import { render, staticRenderFns } from "./PendingPayments.vue?vue&type=template&id=1854c8e4&"
import script from "./PendingPayments.vue?vue&type=script&lang=js&"
export * from "./PendingPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports